import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { AppText } from "./AppText";
import {
  radii,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrap}>
      <AppText weight="semibold">{title}</AppText>
      {description ? (
        <AppText size="sm" tone="muted">
          {description}
        </AppText>
      ) : null}
      {action ? <View style={stylesheet.action}>{action}</View> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    wrap: {
      alignItems: "flex-start",
      justifyContent: "center",
      gap: spacing.xs,
      paddingVertical: spacing.xl,
      paddingHorizontal: spacing.l,
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor: colors.borderStrong,
      borderRadius: radii.m,
      backgroundColor: colors.surface,
    },
    action: { marginTop: spacing.s },
  });
